import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/styles/global.scss";
import "@/assets/fonts/font.css";
import subpageHeader from "@/components/subpageHeader.vue";

/** vconsole 移动端调试 */
// import VConsole from 'vconsole';
// let vConsole =new VConsole();
// Vue.use(vConsole);

Vue.component("subpageHeader", subpageHeader);

Vue.config.productionTip = false;

Vue.use(ElementUI);

router.beforeEach((to, from, next) => {
  next();
  window.scrollTo(0, 0);
});

const userAgent = navigator.userAgent;
console.log(userAgent, "userAgent---------");

const isMobile =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Harmony|OpenHarmony/i.test(
    userAgent
  );
// IOS detection
const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
// Harmony detection
const isHarmony = /HarmonyOS|OpenHarmony|arkweb/i.test(userAgent);
// Android detection
const isAndroid = /Android/.test(userAgent) && !isHarmony;


Vue.prototype.$isMobile = isMobile;
Vue.prototype.$isIOS = isIOS;
Vue.prototype.$isAndroid = isAndroid;
Vue.prototype.$isHarmony = isHarmony;

if (isMobile) {
  console.log("当前设备是移动端");
  if (isIOS) {
    console.log("当前设备是 iOS");
  } else if (isHarmony) {
    console.log("当前设备是 Harmony");
  } else if (isAndroid) {
    console.log("当前设备是 Android");
  }
} else {
  document.documentElement.style.minWidth = "1440px";
  console.log("当前设备是 PC 端");
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
